import React from 'react'
import LayoutBase from '../layouts/Base'
import LayoutMain from '../layouts/Main'
import PilotoAutomatico from '../components/PilotoAutomatico'

export default function PilotoAutomaticoPage() {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_HIPERSYNC_DEMO === 'true') {
    const Demonstracao = require('../components/PilotoAutomatico/demonstracao').default
    return <Demonstracao />
  }
  return <LayoutBase><LayoutMain><PilotoAutomatico /></LayoutMain></LayoutBase>
}
